import {apiDelete, apiGet, apiPost, apiPut} from "./api";

export interface ProviderData {
    AccessKey: string | null;
    Provider: string;
    UpdatedAt: string;
    Minute: string | null;
    Hour: string | null;
    Path: string;
    Region: string;
    DataSource: string;
    SecretKey: string;
    OrgId: string | null;
    Bucket: string;
    CreatedAt: string;
    TableFields: TableField[];
    HasHeaderCsv: boolean;
}

export interface TableField {
    Name: string;
    ApiName: string;
    Type: string;
    Index: number;
    ConvertRule: string;
    NotSend: boolean,
}

export interface ProviderResponse {
    message: string;
    data: ProviderData;
}

export const getProviderDetail = async (searchParams: any): Promise<ProviderResponse | null> => {
    const res = await apiGet(`/batch-job/storage-provider`, searchParams);
    return res as ProviderResponse;
};

export const createStorageProvider = async (body: {
    data_source: "s3" | "window";
    access_key: string | null;
    hour?: string | null;
    minute?: string | null;
    secret_key?: string | null;
    provider?: "aws" | null;
    path?: string | null;
    bucket?: string | null;
    region?: string | null;
}) => {
    return await apiPost(`/batch-job/storage-provider`, body);
};

export const updateStorageProvider = async (body: {
    data_source: "s3" | "window";
    access_key: string | null;
    hour?: string | null;
    minute?: string | null;
    secret_key?: string | null;
    provider?: "aws" | null;
    path?: string | null;
    bucket?: string | null;
    region?: string | null;
}) => {
    return await apiPut(`/batch-job/storage-provider`, body);
};

export interface DisconnectMessageResponse {
    message: string;
    data: ProviderData
}

export const disconnectStorageProvider = async (): Promise<DisconnectMessageResponse> => {
    return await apiDelete(`/batch-job/storage-provider`) as DisconnectMessageResponse;
};

export const updateSyncTime = async (searchParams: any): Promise<ProviderResponse> => {
    const res = await apiPut(`/batch-job/storage-provider/update-time`, searchParams);
    return res as ProviderResponse;
};

export const syncImmediately = async (): Promise<any> => {
    return await apiPost(`/batch-job/trigger-sync-and-upload`, {})
}

export const validateFormula = async (formula: string): Promise<any> => {
    return await apiPost(`/batch-job/storage-provider/check-convert-rule`, {
        formula,
    })
}

export interface AccessControlLogData {
    createdAt: string;
    action: string;
    status: string;
    success_count?: number;
    error_count?: number;
    message?: string;
}

export interface AccessControlLogResponse {
    message: string;
    data: AccessControlLogData[];
}

export const getAccessControlLog = async (searchParams: any): Promise<AccessControlLogResponse | null> => {
    const res = await apiGet(`/batch-job/storage-provider/logs`, searchParams);
    return res as AccessControlLogResponse;
};
